import { render, staticRenderFns } from "./Vaalit.vue?vue&type=template&id=35174e5a&scoped=true"
var script = {}
import style0 from "./Vaalit.vue?vue&type=style&index=0&id=35174e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35174e5a",
  null
  
)

export default component.exports